// dysonStationAnimation.js
var DysonStationAnimation = pc.createScript('dysonStationAnimation');


DysonStationAnimation.attributes.add('dysonGen' , {type:'entity', title:'dysonGenerator'});
DysonStationAnimation.attributes.add('line' , {type:'entity', title:'line'});

// initialize code called once per entity
DysonStationAnimation.prototype.initialize = function() {
    var that = this;
    this.pointAR = [];
    this.dScript = this.dysonGen.script.dysonSphereGenerator;
    this.randomA = new pc.Vec3();
    this.randomB = new pc.Vec3();
    this.app.on('DysonGenerator:StartAnim', this.regStation, this);
    this.app.on('DysonGenerator:playThis', this.player, this);
    this.app.on('systemGenerator:kill', this.stopIt, this);
    this.systems = this.app.root.findByName('dysonSystems');
    this.reg = false;
    this.timeTween = null;
    this.flashTween = null;
    this.firstTime = true;
    this.stopper = false;
    this.lineStartScale = this.line.getLocalScale();
};

DysonStationAnimation.prototype.regStation = function(de) {
    this.stopper = false;
    if(this.timeTween !== null){
        this.timeTween.stop();
        this.flashTween.stop();
    }
    this.pointAR = de;

    this.reg = true;
    this.firstTime = false;
    this.line.enabled = true;
    this.rayShooter();
};

DysonStationAnimation.prototype.player = function(){

};

DysonStationAnimation.prototype.stopIt = function(){
    this.stopper = true;
    this.entity.enabled = false;
    this.line.enabled = false;
    if(this.timeTween !== null){
        this.timeTween.stop();
        this.flashTween.stop();
    }
   //this.initialize();
};

DysonStationAnimation.prototype.rayShooter = function() {
    if(this.timeTween !== null){
        this.timeTween.stop();
        this.flashTween.stop();
    }

    
    var ent = this.pointAR[Math.floor(Math.random(0,1) * this.pointAR.length)].children[0];
    this.randomA = ent.getPosition();
    this.randomB = this.entity.getPosition();
    var distance = this.randomA.distance(this.randomB);
    this.line.setPosition(this.randomB);
    this.line.lookAt(this.randomA);
    var dv3 = new pc.Vec3(1,1, distance);
    this.line.setPosition(this.randomB);
    this.mat = this.line.children[0].model.meshInstances[0].material;
    this.mat.opacity = 0;
    this.mat.update();
    this.line.tween(this.line.getLocalScale()).to(dv3, 0.2, pc.Linear).start();
    this.fader();
};

DysonStationAnimation.prototype.fader = function(){
   // console.log('fader');
    if(this.reg){
        var ent = this.line.children[0];
        var tMat = this.mat;
        var that = this;
        
        //console.info(mat);
        var opac ={value:0.0};

        this.flashTween = ent
            .tween(opac)
            .to({value:0.5}, 0.2, pc.Linear)
            .on('update', function(){
                tMat.opacity = opac.value;
                tMat.update();
            })
             .on('complete', function(){
                if(that.entity.parent.enabled){
                    that.timeDilation();
                } else {
                    that.killLines();
                }
             })
            .yoyo(true)
            .repeat(2)
            .start();
    }  
};

DysonStationAnimation.prototype.killLines = function() {
    this.mat.opacity = 0;
};

DysonStationAnimation.prototype.timeDilation = function() {
    var here = this;
    var rndTime = Math.random(0,3)*2;
    this.timeTween = this.entity
        .tween(this.entity.getLocalPosition())
        .to(this.entity.getLocalPosition(), 0.01, pc.Linear)
        .on('complete', function(){
           here.rayShooter();
        })
        .delay(rndTime)
        .start();
};


// swap method called for script hot-reloading
// inherit your script state here
// DysonStationAnimation.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

